export default function TeamClients() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Clients Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
